// @flow

// Effect Managers
import { call, put, take } from 'redux-saga/effects'

// Constants
import { UPDATE_MAP } from '../constants'

// Action creators
import { updateMap } from '../actions'

export default function *watchMapUpdates (): Generator<*, *, *> {
  while (true) {
    const payload = yield take(UPDATE_MAP)

    const action = yield call(updateMap, payload)
    yield put(action)
  }
}
